const DEFAULT_LIMIT = 8;

export function buildNbaSimilarSeasonsPath({
  playerId,
  season,
  limit = DEFAULT_LIMIT,
  excludeSamePlayer = true,
  model,
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    excludeSamePlayer: excludeSamePlayer ? "true" : "false",
  });
  if (model) params.set("model", model);
  return `/nba/players/${encodeURIComponent(playerId)}/seasons/${encodeURIComponent(season)}/similar?${params}`;
}

export function buildMlbSimilarSeasonsPath({
  playerId,
  season,
  role,
  limit = DEFAULT_LIMIT,
  excludeSamePlayer = true,
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    excludeSamePlayer: excludeSamePlayer ? "true" : "false",
  });
  if (role) params.set("role", role);
  return `/players/${encodeURIComponent(playerId)}/seasons/${encodeURIComponent(season)}/similar?${params}`;
}

export function buildNflSimilarSeasonsPath({
  playerId,
  season,
  role,
  limit = DEFAULT_LIMIT,
  excludeSamePlayer = true,
} = {}) {
  const roleParam = typeof role === "string" ? role.trim() : "";
  if (!roleParam) {
    throw new Error("NFL similar seasons role is required");
  }

  const params = new URLSearchParams({
    limit: String(limit),
    excludeSamePlayer: excludeSamePlayer ? "true" : "false",
  });
  params.set("role", roleParam);
  return `/nfl/players/${encodeURIComponent(playerId)}/seasons/${encodeURIComponent(season)}/similar?${params}`;
}
